/**
 * GTD Energy Level - matching actions to available energy
 * Helps optimize productivity based on current mental/physical state
 */
export class EnergyLevel {
  private constructor(private readonly level: 'low' | 'medium' | 'high') {}

  static low(): EnergyLevel {
    return new EnergyLevel('low');
  }

  static medium(): EnergyLevel {
    return new EnergyLevel('medium');
  }

  static high(): EnergyLevel {
    return new EnergyLevel('high');
  }

  isLow(): boolean {
    return this.level === 'low';
  }

  isMedium(): boolean {
    return this.level === 'medium';
  }

  isHigh(): boolean {
    return this.level === 'high';
  }

  /**
   * Can this action be performed with the available energy level?
   * GTD principle: Match actions to available energy
   */
  canBePerformedWhen(available: EnergyLevel): boolean {
    const levels = { low: 1, medium: 2, high: 3 };
    return levels[this.level] <= levels[available.level];
  }

  equals(other: EnergyLevel): boolean {
    return this.level === other.level;
  }

  toString(): string {
    return this.level;
  }

  valueOf(): string {
    return this.level;
  }
}